<template>
  <section class="form-section">
    <h5 class="section-title">{{ title }}</h5>
    <div class="section-content">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.form-section {
  margin-bottom: 30px;
}

.section-title {
  text-align: center;
  background-color: rgb(43, 0, 128);
  border-radius: 5px;
  color: white;
  margin: 0 0 20px 0;
  padding: 10px;
  font-size: 1.1rem;
}

.section-content {
  background: transparent;
  padding: 20px;
  border-radius: 5px;
}
</style>
